import type { FilterName, FilterRange, FilterValue } from "../../types/dreson";

import { DRESON_PREFIX, FILTER_NAME, FilterBlacklist, isFilterRange } from "../../types/dreson/constants";
import { DresonFilterMatch } from "./DresonFilterMatch";

export class DresonMap extends Map<FilterName, FilterValue> {
  get regex(): RegExp {
    const reGroupPrefix = `(${DRESON_PREFIX.IST}|${DRESON_PREFIX.AB}|${DRESON_PREFIX.BIS}|${DRESON_PREFIX.SUCHBEGRIFF})`;
    const reGroupName = ".([0-9a-zA-Z-%]+)";
    const reGroupValues = "[.]?([0-9a-z%.\\-_]*)";
    return new RegExp(`\\(${reGroupPrefix}${reGroupName}${reGroupValues}\\)`, "g");
  }

  setRule(rule: string): void {
    for (const matches of rule.matchAll(this.regex)) {
      const filter = new DresonFilterMatch(matches);
      if (this.get(filter.name)) {
        this.set(filter.name, Object.assign(this.get(filter.name) as string, filter.value));
      } else {
        this.set(filter.name, filter.value);
      }
    }
  }

  private isKeyValueEqual(key: FilterName, value: FilterValue): boolean {
    return (
      (typeof value == "string" && key.toLowerCase() == value.toLowerCase()) ||
      (Array.isArray(value) && value.length == 1 && key.toLowerCase() == value[0].toLowerCase())
    );
  }

  equals = (dresonMap: DresonMap) =>
    this.get(DRESON_PREFIX.SUCHBEGRIFF) === dresonMap.get(DRESON_PREFIX.SUCHBEGRIFF) &&
    JSON.stringify(this.getAllFilterNames) == JSON.stringify(dresonMap.getAllFilterNames);

  get getAllFilterNames(): string[] {
    let filterList: string[] = [];
    this.forEach((value: FilterValue, key: FilterName) => {
      if (FilterBlacklist.includes(key as FILTER_NAME)) {
        return;
      }

      if (this.isKeyValueEqual(key, value) || value == "") {
        filterList.push(key);
        return;
      }

      if (isFilterRange(value)) {
        const range: FilterRange = value;
        const suffix: string = key === FILTER_NAME.PREIS ? "€" : key.substring(key.lastIndexOf(" in ") + 4, key.length);
        if (!range.bis) {
          filterList.push(`ab ${range.ab} ${suffix}`);
        } else if (!range.ab) {
          filterList.push(`bis ${range.bis} ${suffix}`);
        } else {
          filterList.push(`${range.ab} - ${range.bis} ${suffix}`);
        }

        return;
      }

      if (Array.isArray(value)) {
        filterList = [...filterList, ...value];
        return;
      }

      filterList.push(value.toString());
    });
    return filterList;
  }
}
